import { DebugProcessingPanel } from '@/components/debug';

export default function DebugPage() {
  return (
    <div className="max-w-4xl mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">调试工具</h1>
      <DebugProcessingPanel />
    </div>
  );
}
